/* eslint-disable import/prefer-default-export */
export function ErrorTemplate({ error }) {
  if (!error) return "";

  if (Array.isArray(error)) {
    return (
      <div>
        {error.map((line) => (
          <div className="product error_tmp" key={line}>
            <div className="product-desp">
              <h3 className="error-heading">{line}</h3>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="product error_tmp">
      <div className="product-desp">
        <h3 className="error-heading">{error}</h3>
      </div>
    </div>
  );
}
